import { Tooltip, Typography } from 'antd';

import { StyledTooltipIcon, Wrapper } from './CardLabel.styled';

interface CardLabelProps {
  title: string;
  tooltipTitle?: string;
  disabled?: boolean;
}

export const CardLabel = (props: CardLabelProps) => {
  const { title, tooltipTitle, disabled } = props;
  return (
    <Wrapper $disabled={disabled}>
      <Typography.Text>{title}</Typography.Text>
      {tooltipTitle && (
        <Tooltip title={tooltipTitle}>
          <StyledTooltipIcon />
        </Tooltip>
      )}
    </Wrapper>
  );
};
